import { render, staticRenderFns } from "./PopupAddToNotebook.vue?vue&type=template&id=5a0b93ad&"
import script from "./PopupAddToNotebook.vue?vue&type=script&lang=js&"
export * from "./PopupAddToNotebook.vue?vue&type=script&lang=js&"
import style0 from "./PopupAddToNotebook.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports